__webpack_require__.p = "https://sengrpg.hkust.edu.hk/summercamp/app/";